import { useState, useEffect } from 'react'

const useExpensesSort = (initialItems) => {
  const [sortConfig, setSortConfig] = useState({
    key: 'date',
    direction: 'desc',
  })
  const [sortedItems, setSortedItems] = useState(initialItems)

  useEffect(() => {
    const { key, direction } = sortConfig
    const sorted = [...initialItems].sort((a, b) => {
      const aVal = a.ecritures[0][key]
      const bVal = b.ecritures[0][key]
      if (aVal < bVal) return -1
      if (aVal > bVal) return 1
      return 0
    })

    if (direction === 'desc') {
      sorted.reverse()
    }

    setSortedItems(sorted)
  }, [sortConfig, initialItems])

  const handleSort = (key) => {
    if (sortConfig.key === key) {
      setSortConfig({
        key,
        direction: sortConfig.direction === 'asc' ? 'desc' : 'asc',
      })
    } else {
      setSortConfig({
        key,
        direction: 'asc',
      })
    }
  }

  const sortEcritures = (ecritures) => {
    const { key, direction } = sortConfig
    const sorted = [...ecritures].sort((a, b) => {
      if (a[key] < b[key]) return -1
      if (a[key] > b[key]) return 1
      return 0
    })
    return direction === 'desc' ? sorted.reverse() : sorted
  }

  return { sortedItems, handleSort, sortConfig, sortEcritures }
}

export default useExpensesSort
